import { render } from "./IconTransparent.vue?vue&type=template&id=6d3c71a1&scoped=true"
const script = {}

import "./IconTransparent.vue?vue&type=style&index=0&id=6d3c71a1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3c71a1"]])

export default __exports__